import React from "react";
import { withRouter } from 'react-router';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as coupleAction from '../action/coupleAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      confirm: false,
  	}
  }

  _coupleRequestRelease() {
    this.props.coupleRelease( () => {
      this.props.history.push('/');
    });
  }

  render() {
    return (
      <div style={{maxWidth:'400px', margin:'auto'}}>

        <div style={{margin:'15px'}}>
          <Box className='postItem round12' boxShadow={2} style={{background:'#FFF'}}>
            <div style={{padding:'10px'}}>
              <h2 align='center'>カップリングの解除</h2>

              <div style={{margin:'5px'}}>
                カップリングを一方的に解除すると規約違反となります。<br/>
                パートナーとお話合いの上解除を行ってください
              </div>

              <div style={{margin:'5px'}}>
                お相手様と同意の上でカップリングを解除しますか？
                <Checkbox
                  checked={this.state.confirm}
                  onChange={ () => this.setState({confirm: (this.state.confirm) ? false: true })}
                  color="primary"
                />
              </div>

              <div align='center' style={{padding:'10px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{minWidth:'200px'}}
                  onClick={ () => this._coupleRequestRelease() }
                  disabled={ this.state.confirm ? false: true }
                >
                  <span style={{fontSize:'1.2em'}}>カップリングを解除する</span>
                </Button>
              </div>
            </div>
          </Box>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
    ...coupleAction,
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comp));
